import {createContext, useEffect, useState, useContext, useCallback} from "react";
import { getSubRoot } from '../utils/utils';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Creazione del contesto
const PageSettingsContext = createContext();

// Hook personalizzato per usarlo più facilmente
export const usePageSettings = () => useContext(PageSettingsContext);

// Provider
export const PageSettingsProvider = ({ children }) => {
  const [collectionGridShowed, setCollectionGridShowed] = useState('')
  const [viewMode, setViewMode] = useState("matchboard");
  const [ingestionViewMode, setIngestionViewMode] = useState('carousel');
  const [carouselOverflows, setCarouselOverflows] = useState(false);
  const [carouselPinned, setCarouselPinned] = useState(false);
  const [hasLiveJobs, setHasLiveJobs] = useState(false);
  const [open, setOpen] = useState(false);
  const [createMode, setCreateMode] = useState(false);
  const [competition, setCompetition] = useState();
  const [search, setSearch] = useState('');
  const [date, setDateRaw] = useState(new Date());
  const [dateVersion, setDateVersion] = useState(0);
  const setDate = (valueOrUpdater) => {
    setDateRaw(valueOrUpdater);
    setDateVersion((v) => v + 1);
  };
  const [calendarView, setCalendarView] = useState('timeGridDay');
  const [volume, setVolume] = useState(100);
  const [muted, setMuted] = useState(false);
  const [forwardClip, setForwardClip] = useState({});
  
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.up("xs"));
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));

    const getPageSize = useCallback(() => {
        if (isLg) return 20;
        if (isMd) return 16;
        if (isSm) return 12;
        if (isXs) return 8;
        return 8;
    }, [isLg, isMd, isSm, isXs]);

  useEffect(() => {
    if(competition === undefined){
      let newCompetition = getSubRoot(location.pathname)
      newCompetition = ''
      setCompetition(newCompetition)
    }
  },[])

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <PageSettingsContext.Provider value={{
      forwardClip,
      setForwardClip,
      getPageSize,
      competition,
      setCompetition,
      search,
      setSearch,
      date,
      setDate,
      dateVersion,
      calendarView,
      setCalendarView,
      viewMode,
      setViewMode,
      ingestionViewMode,
      setIngestionViewMode,
      carouselOverflows,
      setCarouselOverflows,
      carouselPinned,
      setCarouselPinned,
      hasLiveJobs,
      setHasLiveJobs,
      open,
      handleToggle,
      collectionGridShowed,
      setCollectionGridShowed,
      volume,
      setVolume,
      muted,
      setMuted,
      createMode,
      setCreateMode
    }}>
      {children}
    </PageSettingsContext.Provider>
  );
};
